import React, { useEffect, useState } from "react";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { useNavigate } from "react-router-dom";
import { GetAllCustomersByStore, DeleteCustomer } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Customers = () => {
  const navigate = useNavigate();
  const { storeG, userPermID } = useStateContext();
  const [AllCustomers, setAllCustomers] = useState("");
  const [Customer_id, setCustomer_id] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const customersGrid = [
    {
      field: "name",
      headerText: "Name",
      minWidth: "180",
      width: "360",
      maxWidth: "640",
      textAlign: "left",
    },
    {
      field: "phone",
      headerText: "Phone",
      minWidth: "140",
      width: "180",
      maxWidth: "200",
      textAlign: "Center",
    },
    {
      field: "email",
      headerText: "Email",
      minWidth: "140",
      width: "220",
      maxWidth: "240",
      textAlign: "left",
    },
    {
      field: "term",
      headerText: "Term",
      minWidth: "140",
      width: "220",
      maxWidth: "280",
      textAlign: "left",
    },
    {
      field: "contact_name",
      headerText: "Contact Name",
      minWidth: "180",
      width: "320",
      maxWidth: "420",
      textAlign: "left",
    },
    {
      field: "balance",
      headerText: "Balance",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      format: "C2",
      textAlign: "right",
    },
    {
      field: "contact_name",
      headerText: "Contact Name",
      minWidth: "180",
      width: "320",
      maxWidth: "420",
      textAlign: "left",
    },
  ];

  const handleAddCustomerClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate(`/Customer/AddCustomer`, {
      state: { fromPage: "Customer" },
    });
  };

  const handleEditCustomerClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Customer_id !== "") navigate(`/Customer/EditCustomer/${Customer_id}`);
    else showInfoToast("Info!", "Please select customer to edit!");
  };

  const handleDeleteCustomerClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (Customer_id !== "") {
        if (window.confirm(`Are you sure you want to Delete this customer?`)) {
          const response = await DeleteCustomer(Customer_id);
          if (response.success) {
            showSuccessToast("Success!", "Customer deleted successfully.");
            window.location.reload();
          } else
            showErrorToast(
              "Error!",
              "Customer failed to delete: " + response.message,
            );
        }
      } else showInfoToast("Info!", "Please select customer to delete.");
    } catch (error) {
      showErrorToast("Error!", "Customer failed to delete!");
    }
  };

  const handleViewCustClick = () => {
    TimeoutUtility.resetTimeout();
    if (Customer_id !== "") navigate(`/Customer/ViewCustomer/${Customer_id}`);
    else showInfoToast("Info!", "Please select customer to view.");
  };

  const handleRowSelected = (args) => setCustomer_id(args.data.customer_id);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      const resp = await GetAllCustomersByStore(storeG.store_id);
      setAllCustomers(resp.data || []);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        setloading(true);
        trackPromise(
          GetAllCustomersByStore(storeG.store_id)
            .then((result) => setAllCustomers(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Accounts" title="CUSTOMERS" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(12) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddCustomerClick} />
            </Col>
          )}
          {userPermID.includes(13) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditCustomerClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Delete" onClick={handleDeleteCustomerClick} />
              </Col>
            </>
          )}
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllCustomers}
        cols={customersGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(11) && handleViewCustClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Customers;
